import { useSelector } from "react-redux";

const useFavourites = () => {
    const { watches } = useSelector((state) => state.watches);
    const { reads } = useSelector((state) => state.reads)
    const { learns } = useSelector((state) => state.learns)

    const { faveWatches, faveReads, faveLearns } = useSelector((state) => state.fave);

    const parsedFaveWatches = faveWatches ? Object.values(faveWatches).map(faveWatch => parseInt(faveWatch)) : [];
    const filteredWatches = parsedFaveWatches && watches.filter(watch => parsedFaveWatches.includes(watch.id));

    const parsedFaveReads = faveReads ? Object.values(faveReads).map(faveRead => parseInt(faveRead)) : [];
    const filteredReads = parsedFaveReads && reads.filter(read => parsedFaveReads.includes(read.id));

    const parsedFaveLearns = faveLearns ? Object.values(faveLearns).map(faveLearn => parseInt(faveLearn)) : [];
    const filteredLearns = parsedFaveLearns && learns.filter(learn => parsedFaveLearns.includes(learn.id));

    const noFaves = (!filteredReads[0] && !filteredLearns[0] && !filteredWatches[0])

    return { filteredWatches, filteredReads, filteredLearns, noFaves };
};

export default useFavourites;
